import { computed, inject, Injectable, signal } from '@angular/core';
import { PlatformGraphQlService } from '../graphql/platform-graphql.service';
import { PlayerRestrictionsType } from '../../types/restrictions.type';
import { PlayerRestrictionsEnum } from '../../enums/restrictions.enum';
import { UserService } from './user.service';
import { ReplaySubject, switchMap } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class UserRestrictionsService {

  private _api = inject(PlatformGraphQlService);
  private _user = inject(UserService);

  public isFullAccountLock = computed(() => this._playerRestrictions().isFullAccountLock);
  public isBetAccountLock = computed(() => this._playerRestrictions().isBetAccountLock);

  public isResolvePlayerRestrictions$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  private _playerRestrictions = signal<PlayerRestrictionsType>({
    isFullAccountLock: false,
    isBetAccountLock: false,
  });

  public initPlayerRestrictions() {
    this._user.auth$.pipe(
      filter(auth => !!auth),
      switchMap(() => this._api.playerRestrictions()),
    ).subscribe(data => {
      const restrictions = data.data.result.map(item => item.restrictionName);
      this._resolvePlayerRestrictions(restrictions);
      this.isResolvePlayerRestrictions$.next(true);
    });
  }

  private _resolvePlayerRestrictions(restrictions: string[]) {
    if (restrictions.includes(PlayerRestrictionsEnum.FULL_LOCK_ACCOUNT)) {
      this._patchPlayerRestrictions({ isFullAccountLock: true });
    }

    if (restrictions.includes(PlayerRestrictionsEnum.BET_BLOCK)) {
      this._patchPlayerRestrictions({ isBetAccountLock: true });
    }
  }

  private _patchPlayerRestrictions(entities: Partial<PlayerRestrictionsType>) {
    this._playerRestrictions.update(state => {
      return {
        ...state,
        ...entities,
      };
    });
  }
}
